import createStyleSheet from './create-stylesheet';
import createMediaQueryStyles from './utils/create-media-query-styles';
const StyleSheet = {
  create: createStyleSheet
};
export { StyleSheet, createMediaQueryStyles };